import React, { createContext, useContext } from 'react';

export const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  return (
    <UserContext.Provider value={null}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
